const colors = {
  dark: "#000000",
  white: "#DEDBDC",
  blue: "#041C23",
  red: "#5A1520",
  yellow: "#F5EDB5",
};

export default colors;
